import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from 'projects/Administration/src/app/business-entities/brand.model';
import { TechnicalManual } from 'projects/Administration/src/app/business-entities/technical-manual-model';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import { TechnicalManualBusinessService } from 'projects/Administration/src/app/business-services/technical-manual.service';
import * as Enums from './../../../../../../../../Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-view-technical-manual',
  templateUrl: './view-technical-manual.component.html'
})
export class ViewTechnicalManualComponent implements OnInit {

  viewTechnicalManual = false;
  viewTechnicalManualForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  id: number;
  technicalManual: TechnicalManual;
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private technicalManualService: TechnicalManualBusinessService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private activeModal: NgbActiveModal
  ) { }



  ngOnInit(): void {
    this.viewTechnicalManualForm = this.formBuilder.group({
      brand: [''],
      manualUrl: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      isActive: ['']
    });

    this.getBrandData();
    this.viewTechnicalManualForm.controls.brand.disable();
  }
  async getBrandData() {
    this.id = this.technicalManualService.technicalManualId
    await this.GetAllBrand();
    await this.getTechnicalManual(this.id);
  }
  get cpf() {
    return this.viewTechnicalManualForm.controls;
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  async getTechnicalManual(id: number) {
    this.spinner.show();
    await this.technicalManualService.getTechnicalManualById(id).then(result => {
      if (result) {
        this.technicalManual = result;
        this.viewTechnicalManualForm.patchValue({
          ...result,
        })
      }
    })
    this.spinner.hide();
  }
  OnClose() {
    this.activeModal.close({success:false})
  }

  editTechnicalManuals() {
    this.spinner.show();
    let currentUser = '';
    const viewModel: any = {
      ...this.viewTechnicalManualForm.value,
      isActive: (this.viewTechnicalManualForm.get('isActive').value === '' ? false : this.viewTechnicalManualForm.get('isActive').value),
      updatedBy: currentUser,
      brandCode: this.brandList.find(x => x.brandName === this.viewTechnicalManualForm.get('brand').value).brandCode,
      brandId: this.brand.find(x => x.brandName === this.viewTechnicalManualForm.get('brand').value).id,
      id: this.technicalManual.id,
      brand: this.viewTechnicalManualForm.get('brand').value
    }
    this.technicalManualService.editTechnicalManual(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        let succesMsg = this.translate.instant("lblTechnicalManualUpdated");
        this.toastr.success(succesMsg);
        this.activeModal.close({
          success: true
        });
        this.spinner.hide();
      }
      else if (res.responseCode === Enums.ErrorCodes.InterrnalError) {
        let internalErrorMessage = this.translate.instant("lblRentalCarEditInternalError");
        this.spinner.hide();
        this.toastr.error(internalErrorMessage);
      }
    });
  }
}
